import { CompletionStatus } from './mentoring-program-enrollments';

export enum MentoringProgramGuideRole {
  MENTOR = 'mentor',
  MENTEE = 'mentee',
  MENTOR_AND_MENTEE = 'mentor_and_mentee',
};

export enum MentoringProgramGuideRequirementType {
  MILESTONE = 'milestone',
  SESSION = 'session',
  CONNECTION_SESSION = 'connection_session',
};

export enum MentoringProgramMilestone {
  PROFILE_COMPLETION = 'profile_completion',
  PROFILE_REVIEW = 'profile_review',
};

export type ProfileCompletionCriteria = {
  state: MentoringProgramMilestone.PROFILE_COMPLETION;
  status: CompletionStatus.COMPLETED;
};

export type SessionSequenceCriteria = {
  sequence: number[];
};

export type ConnectionSessionCriteria = {
  upperLimit: number;
};

export type MentoringProgramGuideCriteria =
  | ProfileCompletionCriteria
  | SessionSequenceCriteria
  | ConnectionSessionCriteria;

export type MentoringProgramGuideRequirement = {
  id: number;
  type: MentoringProgramGuideRequirementType;
  criteria: MentoringProgramGuideCriteria;
};

export type MentoringProgramGuideContent = {
  fileName: string;
  url: string;
};

export interface MentoringProgramGuideVideo
  extends MentoringProgramGuideContent {
  thumbnailUrl: string;
};

export interface MentoringProgramGuideAttachment
  extends MentoringProgramGuideContent {
  fileSize: number;
  contentType: string;
};

export type MentoringProgramGuide = {
  id: number;
  title: string;
  content: string;
  role: MentoringProgramGuideRole;
  mentorshipProgramGuideRequirement: MentoringProgramGuideRequirement;
  video: MentoringProgramGuideVideo;
  attachments: MentoringProgramGuideAttachment[];
};
